export default function (store, ev) {
    const { task, batch } = ev;
    const originalTask = store.updateTask(ev);
    // [fixme] a very bad solution, beginning
    const diff = {};
    if (originalTask) {
        for (let key in task) {
            if (task[key] !== originalTask[key]) {
                diff[key] = originalTask[key];
            }
        }
    }
    if (originalTask) {
        for (let key in task) {
            if (typeof originalTask[key] === "undefined") {
                originalTask[key] =
                    typeof task[key] === "boolean" ? false : null;
            }
        }
        if (originalTask.selected) {
            delete originalTask.selected;
        }
    }
    return () => {
        // [fixme] a very bad solution, end
        const newBatch = [];
        if (diff && batch) {
            batch.forEach(t => {
                const task = { ...t };
                for (let key in diff) {
                    task[key] = diff[key];
                }
                newBatch.push(task);
            });
        }
        store.in.exec("update-task", {
            ...ev,
            task: originalTask,
            batch: newBatch,
            $meta: { skipHistory: true },
        });
    };
}
//# sourceMappingURL=update.js.map